/* eslint-disable import/no-mutable-exports */
import AddToClausesListBtn from "./AddToClausesListBtn";

export default AddToClausesListBtn;
